
import { getAppVariable } from '@white-label-helper/get-app-variable';
import { defineComponent } from 'vue';

// Types
import type { NuxtOptionsHead } from '@nuxt/types/config/head';

export default defineComponent({
  name: 'HomePage',

  components: {
    EcommerceHomePage: () => import('@white-label-frontend/ecommerce-home')
  },

  head(): NuxtOptionsHead {
    return {
      title: getAppVariable<string>('page_meta_title', `Search | ${getAppVariable('partner_name')}`),
      meta: [
        { name: 'description', content: getAppVariable('page_meta_description') },
      ],
      link: [
        { rel: 'icon', href: getAppVariable('favicon') },
        { rel: 'apple-touch-icon', href: getAppVariable('favicon') },
      ],
    };
  },
});
